const NotFound = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-[#26aefb] via-[#6CB1D8] to-[#2ca1e3]">
            <div className="text-center text-white">
                <h1 className="text-6xl font-extrabold mb-4">404</h1>
                <h2 className="text-2xl mb-4">¡Oops! Esta página no existe</h2>
                <p className="mb-6">Parece que la ruta que buscas no está disponible. ¡No te preocupes, podemos ayudarte a encontrar algo mejor!</p>
                <a href="/" className="text-lg font-semibold py-2 px-4 bg-white text-gray-900 rounded-full hover:bg-red-400 hover:text-white transition-all">
                    Volver al Inicio
                </a>
            </div>
        </div>
    )
}

export default NotFound
